export const setStartEndDate = (scheduleOfPrograms, programId, scheduleId) => {
    for (let i = 0; i < scheduleOfPrograms.length; i++) {
        if (scheduleOfPrograms[i].id === programId) {
            for (let j = 0; j < scheduleOfPrograms[i].Schedules.length; j++) {
                if (scheduleOfPrograms[i].Schedules[j].id == scheduleId) {
                    return {
                        startDate: scheduleOfPrograms[i].Schedules[j].startDate,
                        endDate: scheduleOfPrograms[i].Schedules[j].endDate
                    }
                }
            }
        }
    }
}